import type { AxiosInstance } from 'axios';
import { getDefaultAxios, getDefaultAxiosWithToken } from './AxiosService';
import type { KeycloakAuth } from '$lib/types';

export interface WalletBalances {
	ethBalance: string;
	maticBalance: string;
	wETHBalance: string;
	wMaticBalance: string;
	tankBalance: string;
}

export class WalletService {
	keyCloack: KeycloakAuth | undefined;
	walletsURL = `/markets/wallets`;
	axios: AxiosInstance;

	constructor(keyCloack?: KeycloakAuth) {
		if (keyCloack) {
			this.keyCloack = keyCloack;
			this.axios = getDefaultAxiosWithToken(keyCloack);
		} else {
			this.axios = getDefaultAxios();
		}
	}

	async getWallets(address: string) {
		let resp = await this.axios.get<WalletBalances>(`${this.walletsURL}/${address}`);
		return resp.data;
	}
}
